import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { DEFAULT_CONTENT_WIDTH } from '../../../../../constants';
import { ApplyStep } from './components/apply-step';
import { VotingCards } from './components/voting-cards';

const backgroundImage = require(`@assets/images/marketplace/home-section-4-curve.svg`);

const HowToJoinSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden bg-bg-primaryLight">
      
      <div
        className={clsx(
          DEFAULT_CONTENT_WIDTH,
          'm-auto ',
          'mt-8 lg:mt-[132px]',
          'pb-7 lg:pb-10'
        )}
      >
        <h1 className={clsx(
          'text-h3 font-bold text-text-primary',
          'leading-[3.7rem]',
          'sm:text-[4.8rem] sm:leading-[5.5rem]'
        )}>
          {t('js.features.marketplace.home.how_to_join_section.title')}
        </h1>
        <div
          className={clsx(
            'flex w-full flex-col-reverse',
            'lg:flex-row lg:justify-between'
          )}
        >
            <div className={clsx('w-full', 'lg:w-[40%]')}>
            <div
              className={clsx('mt-5 flex w-full flex-col', 'md:mt-7', 'lg:mt-[7.2rem]')}
            >
              <ApplyStep
                step={1}
                title={t('js.features.marketplace.home.how_to_join_section.steps.step1_title') ?? ''}
                text={t('js.features.marketplace.home.how_to_join_section.steps.step1_text') ?? ''}
              />
              <ApplyStep
                step={2}
                title={t('js.features.marketplace.home.how_to_join_section.steps.step2_title') ?? ''}
                text={t('js.features.marketplace.home.how_to_join_section.steps.step2_text') ?? ''}
              />
              <ApplyStep
                step={3}
                title={t('js.features.marketplace.home.how_to_join_section.steps.step3_title') ?? ''}
                text={t('js.features.marketplace.home.how_to_join_section.steps.step3_text') ?? ''}
              />
              <ApplyStep
                step={4}
                title={t('js.features.marketplace.home.how_to_join_section.steps.step4_title') ?? ''}
                text={t('js.features.marketplace.home.how_to_join_section.steps.step4_text') ?? ''}
              />
            </div>
          </div>
          <VotingCards />
        </div>
      </div>
    </section>
  );
};

export { HowToJoinSection };
